<template>
  <div>
    <!-- <header>
      <p>个人信息</p>
      {{ userInfo }}
    </header> -->
    <div
      style="height: calc(100vh - 88px); background-color: #fff"
      class="personal"
    >
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="基本信息" name="first">
          <basic ref="basic" @basicList="basicList"></basic>
        </el-tab-pane>
        <el-tab-pane label="所获荣誉" name="second">
          <honor ref="honor" @honor="honor"></honor>
        </el-tab-pane>
        <el-tab-pane label="宣传报道" name="third">
          <propaganda ref="propaganda" @propaganda="propaganda"></propaganda>
        </el-tab-pane>
      </el-tabs>

      <div class="sub">
        <el-button type="warning">保存草稿</el-button>
        <el-button type="primary" @click="sub">提交审核</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store";
import basic from "./components/basic.vue";
import honor from "./components/honor.vue";
import propaganda from "./components/propaganda.vue";
export default {
  components: {
    basic,
    honor,
    propaganda,
  },
  data() {
    return {
      userInfo: store.getters.userInfo,
      activeName: "first",
    };
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    sub() {
      this.$refs.basic.subClick();
      this.$refs.honor.subClick();
      this.$refs.propaganda.subClick();
    },
    //基本信息数据接收
    basicList(val) {
      // console.log(val);
    },
    honor(val) {
      // console.log(val);
    },
    propaganda(val) {
      // console.log(val);
    },
  },
  created() {},
  activated() {},
};
</script>
<style lang="scss" scoped>
.personal {
  // padding: 5px 25px;
  position: relative;
  .sub {
    position: absolute;
    right: 25px;
    top: 8px;
  }
}
/deep/.el-button {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  padding: 0.7rem 0.8rem;
  border: none;
}
/deep/.el-tabs__nav-wrap::after {
  // background-color: transparent;
  width: 100%;
}
/deep/.el-tabs__item {
  height: 3rem;
  line-height: 3rem;
}
/deep/.el-tabs {
  height: 100%;
  display: flex;
  flex-direction: column;
}
/deep/.el-tabs__content {
  flex: 1;
}
/deep/.el-tab-pane {
  height: 100%;
}
</style>
